import React from 'react'
import { useNavigate } from 'react-router-dom';
import ButtonComponent from '../../components/ButtonComponent';

const DataProtectionPolicy = () => {
    const navigate = useNavigate();
    const handleBackToPolicyPage = () => {
        navigate('/documents');
    }
    return (
        <>
            <div className="container mt-5 privacy-policy"><ButtonComponent title='Back to Policy Page' backgroundColor=' #590B21' onClick={handleBackToPolicyPage} /></div>
            <div className="container mt-2 mb-5 py-4 privacy-policy">
                <h3 className='fw-bold'>CURRY KING (PRIVATE) LIMITED</h3>
                <h3 className='fw-bold'>Data Protection Policy</h3>
                <p> Version 1.0 | Effective Date: 1st May 2025</p>
                <p>
                    Curry King (Private) Limited ("we", "our", "us") is committed to safeguarding the privacy and personal data of all individuals who interact with our services via our website, mobile applications (iOS and Android), food carts, or customer service platforms. This Data Protection Policy sets out how we collect, process, store, and protect your personal data in accordance with applicable privacy laws and industry standards.
                </p>
                <hr />
                <h5 className='fw-bold'>1. Purpose and Scope</h5>
                <p>
                    This policy outlines the principles and procedures followed by Curry King in relation to:
                </p>
                <ul>
                    <li>The collection and use of personal data</li>
                    <li>The protection and confidentiality of such data</li>
                    <li>The rights of individuals regarding their personal information</li>
                </ul>
                <p>This policy applies to all data collected through:</p>
                <ul>
                    <li>Our website and mobile applications</li>
                    <li>Telephone or digital customer support channels</li>
                    <li>In-person interactions at food carts and promotions</li>
                </ul>
                <hr />
                <h5 className='fw-bold'>2. Legal Basis for Data Processing</h5>
                <p>We process personal data based on at least one of the following legal grounds:</p>
                <ul>
                    <li>The data subject has given clear consent</li>
                    <li>Processing is necessary to perform a contract or service</li>
                    <li>Processing is required to comply with legal obligations</li>
                    <li>Processing is necessary for our legitimate business interests</li>
                </ul>
                <hr />
                <h5 className='fw-bold'>3. Data We Collect</h5>
                <p>We may collect and process the following categories of personal data:</p>
                <ul>
                    <li><strong>Identification:</strong> Name, phone number, email address</li>
                    <li><strong>Contact:</strong> Delivery address or pickup location</li>
                    <li><strong>Transaction:</strong> Order history, payment details (only via secure gateway)</li>
                    <li><strong>Technical:</strong> IP address, browser type, device identifiers, app usage logs</li>
                    <li><strong>Preferences:</strong> Meal preferences, language, location, feedback</li>
                </ul>
                <p>
                    We do not collect or store sensitive payment card information directly. All payments are handled through certified third-party payment processors.
                </p>
                <hr />
                <h5 className='fw-bold'>4. How We Use Your Data</h5>
                <p>We use personal data for the following purposes:</p>
                <ul>
                    <li>To process and fulfill food orders</li>
                    <li>To manage user accounts and authentication</li>
                    <li>To send order confirmations, updates, and receipts</li>
                    <li>To improve our services through analytics and customer feedback</li>
                    <li>To send promotional communications (if consent is provided)</li>
                    <li>To comply with regulatory or legal obligations</li>
                </ul>
                <hr />
                <h5 className='fw-bold'>5. Data Sharing and Disclosure</h5>
                <p>
                    We do not sell or rent personal data to third parties.
                </p>
                <p>We may share data only with trusted third-party service providers for the purpose of:</p>
                <ul>
                    <li>Payment processing</li>
                    <li>Delivery coordination</li>
                    <li>App and infrastructure hosting</li>
                    <li>Analytics and performance monitoring</li>
                    <li>Marketing campaign management (subject to user consent)</li>
                </ul>
                <p>
                    All third-party vendors are contractually bound to maintain confidentiality and data protection standards.
                </p>
                <hr />
                <h5 className='fw-bold'>6. Data Retention</h5>
                <p>
                    Personal data is retained only for as long as necessary for the purpose it was collected, or to comply with legal, accounting, or reporting obligations. Once no longer required, data is securely deleted or anonymised.
                </p>
                <hr />
                <h5 className='fw-bold'>7. Data Security</h5>
                <p>
                    We implement appropriate technical and organisational security measures to protect personal data from:
                </p>
                <ul>
                    <li>Unauthorised access</li>
                    <li>Accidental loss or destruction</li>
                    <li>Misuse, alteration, or disclosure</li>
                </ul>
                <p>These measures include:</p>
                <ul>
                    <li>Encrypted data transmission (HTTPS, SSL)</li>
                    <li>Role-based access control</li>
                    <li>Secure storage on protected servers</li>
                    <li>Regular security audits and patch management</li>
                </ul>
                <hr />
                <h5 className='fw-bold'>8. User Rights</h5>
                <p>Individuals whose data is processed by Curry King have the following rights:</p>
                <ul>
                    <li>Right to access their personal data</li>
                    <li>Right to request rectification of incorrect data</li>
                    <li>Right to request deletion of their data (subject to legal exceptions)</li>
                    <li>Right to object to or restrict processing in certain circumstances</li>
                    <li>Right to withdraw consent at any time (for processing based on consent)</li>
                </ul>
                <p>
                    To exercise any of the above rights, please contact us at <strong>support@curryking.lk</strong>.
                </p>
                <hr />
                <h5 className='fw-bold'>9. Data Transfers</h5>
                <p>
                    If personal data is transferred outside of Sri Lanka, we will ensure that appropriate safeguards are in place to maintain its confidentiality and protection in accordance with applicable laws.
                </p>
                <hr />
                <h5 className='fw-bold'>10. Children's Data</h5>
                <p>
                    Our services are intended for use by adults. Food may be ordered on behalf of children by their parents or legal guardians. We do not knowingly collect personal data from minors without verifiable parental consent.
                </p>
                <hr />
                <h5 className='fw-bold'>11. Policy Updates</h5>
                <p>
                    We may update this Data Protection Policy periodically to reflect changes in our practices or regulatory requirements. The latest version will always be available on our website and mobile applications, with the effective date clearly indicated.
                </p>
                <hr />
                <h5 className='fw-bold'>12. Contact Information</h5>
                <p>
                    For any questions, concerns, or requests related to this policy or our data handling practices, please contact:
                </p>
                <strong>Curry King (Private) Limited</strong>
                <br />
                55/72, Vauxhall Lane, Colombo 2, Sri Lanka
                <br />
                <strong>Email:</strong> support@curryking.lk
                <br />
                <strong>Phone:</strong> +94 11 444 1333
                <hr />
            </div>
        </>
    )
}

export default DataProtectionPolicy;